/**
 * Сколько дней до конца подписки грейс-период считается правдоподобным.
 *
 * Грейс означает «подписка вот-вот кончится, бэк добирает платёж». Если до
 * конца ещё месяцы, флаг устарел — и показывать по нему плашку значит пугать
 * человека, у которого на том же экране написано «активна до 2027 года».
 */
const GRACE_MAX_DAYS_LEFT = 7

const MS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * Показывать ли предупреждение о грейс-периоде.
 *
 * Флага недостаточно: он приезжает в профиле, а дата окончания — в подписке,
 * и эти два источника обновляются независимо. Сверяем их между собой, чтобы
 * экран не противоречил сам себе.
 */
export const isGraceVisible = (
  graceActive: boolean,
  expiresAt?: string | null
): boolean => {
  if (!graceActive) return false
  // Даты нет — верим флагу: скрыть предупреждение опаснее, чем показать лишнее.
  if (!expiresAt) return true

  const endsAt = new Date(expiresAt).getTime()
  if (!Number.isFinite(endsAt)) return true

  return (endsAt - Date.now()) / MS_IN_DAY <= GRACE_MAX_DAYS_LEFT
}
